import React from "react";
import { useLang } from "../../i18n/LanguageContext";

const AppleGlyph = () => (
  <svg viewBox="0 0 384 512" width="22" height="22" fill="currentColor" aria-hidden="true">
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
  </svg>
);

const PlayGlyph = () => (
  <svg viewBox="0 0 512 512" width="22" height="22" aria-hidden="true">
    <path fill="#00D2FF" d="M47 20 305 256 47 492c-9 5-19-1-19-12V32c0-11 10-17 19-12z" />
    <path fill="#FFCE00" d="m389 208-64-37-63 62 63 62 64-37c18-11 18-39 0-50z" />
    <path fill="#00F076" d="M28 32c0-11 10-17 19-12l215 197-63 39z" />
    <path fill="#FF3A44" d="M262 244 47 480c-9 5-19-1-19-12l234-224z" />
  </svg>
);

export const StoreButton = ({ store = "apple", testId, className = "" }) => {
  const { t } = useLang();
  const isApple = store === "apple";
  return (
    <button
      type="button"
      data-testid={testId}
      className={`group inline-flex items-center gap-3 rounded-2xl bg-petrol px-5 py-3 text-left text-cream transition-transform duration-200 hover:-translate-y-1 hover:bg-[#16344b] focus:outline-none focus:ring-2 focus:ring-terracotta ${className}`}
    >
      <span className="shrink-0">
        {isApple ? <AppleGlyph /> : <PlayGlyph />}
      </span>
      <span className="leading-tight">
        <span className="block text-[10px] uppercase tracking-widest opacity-70">
          {isApple ? t.store.appleTop : t.store.playTop}
        </span>
        <span className="block font-heading text-lg font-bold">
          {isApple ? t.store.appleName : t.store.playName}
        </span>
      </span>
    </button>
  );
};

export const StoreButtons = ({ idPrefix = "hero" }) => (
  <div className="flex flex-wrap gap-3">
    <StoreButton store="apple" testId={`${idPrefix}-app-store-button`} />
    <StoreButton store="google" testId={`${idPrefix}-google-play-button`} />
  </div>
);
